"use client";
import { X } from "lucide-react";
import React, { useEffect, useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/shadcn/popover";
import { useSession } from "next-auth/react";
import clsx from "clsx";
import { Separator } from "@/components/shadcn/separator";
import { Button } from "../shadcn/button";

const PeakIntoSystem = () => {
  const [serverInfo, setServerInfo] = useState({
    ip: "Unknown",
    serverName: "Unknown",
    containerName: "Unknown",
    pageLoadTime: "Calculating...",
  });
  const { data, status } = useSession();
  const [showPeakInfo, setShowPeakInfo] = useState(false);
  useEffect(() => {
    // Fetch server IP and container name from the backend or environment
    const fetchServerInfo = async () => {
      try {
        const startTime = performance.now();

        // Simulate fetching server info (replace with actual API call if needed)
        const response = await fetch("/next/api/server-info");
        const data = await response.json();

        const endTime = performance.now();
        const pageLoadTime = `${(endTime - startTime).toFixed(2)} ms`;

        setServerInfo({
          ip: data.ip || "Unknown",
          serverName: data.serverName || "Unknown",
          containerName: data.containerName || "Unknown",
          pageLoadTime,
        });
      } catch (error) {
        console.error("Failed to fetch server info:", error);
      }
    };

    fetchServerInfo();
  }, []);

  data?.user?.is_admin && console.log("Server Info:", serverInfo);

  return (
    <React.Fragment>
      {status === "authenticated" && data.user.is_admin && (
        <Popover open={showPeakInfo} onOpenChange={setShowPeakInfo}>
          <PopoverTrigger asChild>
            <Button
              className={clsx(
                "fixed bottom-6 left-6 shadow-custom min-h-14 min-w-14 flex items-center justify-center cursor-pointer z-999"
              )}
              onClick={() => {
                setShowPeakInfo(!showPeakInfo);
              }}
            >
              Admin
            </Button>
          </PopoverTrigger>
          <PopoverContent
            className="w-80 ml-5 rounded-xl border border-primary"
            onInteractOutside={(e) => {
              e.preventDefault();
            }}
          >
            <div className="flex justify-between items-center relative">
              <h3 className="text-lg font-semibold">Admin Peek Into System!</h3>
              <div className="absolute right-0 top-2 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground">
                <X onClick={() => setShowPeakInfo(false)} className="h-4 w-4 cursor-pointer" />
                <span className="sr-only">Close</span>
              </div>
            </div>
            <Separator className="my-3" />
            <p>
              <strong>Server IP:</strong> {serverInfo.ip}
            </p>
            <p>
              <strong>Server Name:</strong> {serverInfo.serverName}
            </p>
            <p>
              <strong>Container Name:</strong> {serverInfo.containerName}
            </p>
            <p>
              <strong>Page Load Time:</strong> {serverInfo.pageLoadTime}
            </p>
            <Separator className="my-3" />
          </PopoverContent>
        </Popover>
      )}
    </React.Fragment>
  );
};

export default PeakIntoSystem;
